import CarSearchingAnimation from './CarSearchingAnimation';

export default CarSearchingAnimation;
